import { render, staticRenderFns } from "./AboutBusiness.vue?vue&type=template&id=0f22f238&scoped=true"
import script from "./AboutBusiness.vue?vue&type=script&lang=ts"
export * from "./AboutBusiness.vue?vue&type=script&lang=ts"
import style0 from "./AboutBusiness.vue?vue&type=style&index=0&id=0f22f238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f22f238",
  null
  
)

export default component.exports